module.exports = __webpack_public_path__ + "img/zongping.77cc7dad.png";